import axios from 'axios';

export const viewerBaseUrl = process.env.VUE_APP_VIEWER_BASE_URL;
export const examViewerBaseUrl = process.env.VUE_APP_EXAM_VIEWER_BASE_URL;

export default axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
});
